import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSearch } = FiIcons;

const IQVIASearchBar = ({ onProductSelect, selectedProduct }) => {
  const [query, setQuery] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const availableProducts = [
    'Abiraterone Acetate',
    'Atorvastatin',
    'Rosuvastatin', 
    'Losartan',
    'Capecitabine',
    'Levetiracetam',
    'Sacubitril/Valsartan',
    'Eltrombopag Olamine',
    'Brivaracetam',
    'Mirabegron'
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onProductSelect(query.trim());
      setShowSuggestions(false);
      setQuery('');
    }
  };

  const handleProductClick = (product) => {
    onProductSelect(product);
    setShowSuggestions(false);
    setQuery('');
  };

  const filteredProducts = availableProducts.filter(product =>
    product.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="relative">
      {/* Current Selection */}
      <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-700">
          <strong>Currently Analyzing:</strong> {selectedProduct}
        </p>
      </div>

      {/* Search Form */}
      <form onSubmit={handleSearch} className="relative">
        <div className="flex">
          <div className="relative flex-1">
            <SafeIcon 
              icon={FiSearch} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
            />
            <input
              type="text"
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                setShowSuggestions(e.target.value.length > 0);
              }}
              onFocus={() => setShowSuggestions(query.length > 0)}
              placeholder="Search for a product (e.g., Abiraterone Acetate, Atorvastatin)..."
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            />
          </div>
          
          <button
            type="submit"
            className="px-6 py-3 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all"
          >
            Search Product
          </button>
        </div>
      </form>

      {/* Product Suggestions */}
      {showSuggestions && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
          <div className="p-4">
            <p className="text-sm font-medium text-gray-700 mb-3">Available Products</p>
            <div className="space-y-2">
              {filteredProducts.map((product, index) => (
                <button
                  key={index}
                  onClick={() => handleProductClick(product)}
                  className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left"
                >
                  <div>
                    <p className="font-medium text-gray-900">{product}</p>
                    <p className="text-sm text-gray-600">Generic pharmaceutical product</p>
                  </div>
                  <SafeIcon icon={FiSearch} className="text-gray-400" />
                </button>
              ))}
              
              {filteredProducts.length === 0 && query && (
                <div className="p-3 text-center">
                  <p className="text-gray-500">No products found for "{query}"</p>
                  <p className="text-xs text-gray-400 mt-1">Try searching for available products above</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Quick Access Products */}
      <div className="mt-4">
        <p className="text-sm font-medium text-gray-700 mb-3">Quick Access</p>
        <div className="flex flex-wrap gap-2">
          {availableProducts.slice(0, 6).map((product, index) => (
            <button
              key={index}
              onClick={() => handleProductClick(product)}
              className={`px-3 py-1 text-sm rounded-full transition-colors ${
                selectedProduct === product
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {product}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IQVIASearchBar;